import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyLayoutModule } from './empty-layout/empty-layout.module';
import { HomeLayoutModule } from './home-layout/home-layout.module';
import { LayoutComponent } from './layout.component';
import { RouterModule, RouterOutlet } from '@angular/router';
import { CommonLayoutModule } from './common-layout/common-layout.module';



@NgModule({
  declarations: [LayoutComponent],
  imports: [
    CommonModule,
    EmptyLayoutModule,
    HomeLayoutModule,
    CommonLayoutModule,
    RouterModule,
    RouterOutlet
  ],
  exports: [LayoutComponent],
})
export class LayoutModule { }
